

















import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import Icon from '@/components/Icon.vue';

@Component({
    components: {Icon}
})
export default class TagList extends Vue {
    @Prop(String) classPrefix?: string;
    @Prop({required: true, type: Object}) selectedTag!: TagItem;
    @Prop({type: Boolean, default: false}) dynamic!: boolean;
    @Prop({required: true, type: Array}) tagList!: TagItem[];

    select(tag: TagItem) {
        this.$emit('update:selectedTag', tag);
    }

    add() {
        this.$router.replace('/tags');
    }
}
